export default __webpack_public_path__ + "static/media/house3.86bc6355.png";